<template>
  <div class="sign-home">
    <NavBar :navList="NavList" :logoUri="logoUri" routerName="home" title="我的文档"></NavBar>
    <div class="sign-page-content" >
      <router-view class="child"></router-view>
    </div>
    <div class="sign-bottom">
      <BottomBar></BottomBar>
    </div>
  </div>
</template>

<script>
import NavBar from "@/views/navbars/NavBar.vue";
import BottomBar from "@/views/bottombar/BottomBar.vue";
export default {
  name: "home",
  data() {
    return {
      NavList: [
        {
          index: "/document/all_information",
          title: "全部文档"
        },
        {
          index: "/document/wait_for_me",
          title: "待我签"
        },
        {
          index: "/document/wait_for_other",
          title: "待他人签"
        },
        {
          index: "/document/completed",
          title: "已完成"
        },
        {
          index: "/document/overdue",
          title: "已过期"
        },
        {
          index: "/document/user_refuse",
          title: "已拒绝"
        },
        {
          index: "/document/drafts",
          title: "草稿箱"
        }
      ],
      logoUri: require("@/assets/img/document.png"),
      height: 500
    };
  },
  created() {
    this.height = this.$store.state.pageViewHeigh;
  },
  components: {
    NavBar,
    BottomBar
  }
};
</script>

<style scoped lang="scss">
.sign-home {
  height: 100%;
  background-color: $bg-color;
}
.sign-page-content{
  height: -webkit-calc(100% - 196px);
  height: -moz-calc(100% - 196px);
  height: calc(100% - 196px);
}

</style>

